import React from "react";

import EyeIcon from "../../../assets/icons/EyeIcon";
import EditIcon from "../../../assets/icons/EditIcon";
import RedDeleteIcon from "../../../assets/icons/RedDeleteIcon";
import NoDataIcon from "../../../assets/icons/NoDataIcon";
import { useSelector } from "react-redux";
import "../../../style/product.css";

const ProductTable = ({ products, onView, onEdit, onDelete }) => {
  const { isPartsURL, isAccessoriesURL } = useSelector((state) => state.domain);

  const getStatusColor = (status) => {
    switch (status) {
      case "out of stock":
        return "#FF5356";
      case "low":
        return "#FE9400";
      case "in stock":
        return "#0CAE00";
      default:
        return "#FF5356";
    }
  };

  return (
    <div className="product-table-container">
      {/* Fixed Header */}
      <div className="product-table-header-container">
        <table className="product-table">
          <thead style={{ borderRadius: "8px" }}>
            <tr>
              <th style={{ borderTopLeftRadius: "8px" }}>NAME</th>
              <th>CATEGORY</th>
              <th>AVG. BUYING PRICE</th>
              <th>AVG. SELLING PRICE</th>
              <th>IN STOCK</th>
              <th>STATUS</th>
              <th style={{ textAlign: "center", borderTopRightRadius: "8px" }}>
                ACTION
              </th>
            </tr>
          </thead>
        </table>
      </div>

      {/* Scrollable Body */}
      <div className="product-table-body-container">
        <table className="product-table">
          <tbody>
            {products.length === 0 && (
              <tr>
                <td colSpan="7" className="no-products-message">
                  <div
                    className=""
                    style={{
                      marginBottom: "4rem",
                      marginTop: "4rem",
                    }}
                  >
                    <NoDataIcon />
                    <h3 style={{ marginTop: "2rem" }}>No Products Found</h3>
                  </div>
                </td>
              </tr>
            )}
            {products.map((product) => (
              <tr key={product.id}>
                <td className="product-name">
                  <div>
                    <div>{product.name}</div>
                    <div
                      style={{
                        fontSize: "0.8em",
                        color: "#666",
                        marginTop: "4px",
                      }}
                    >
                      {product.ram && `${product.ram}`}
                      {product.ram && product.storage && " | "}
                      {product.storage && `${product.storage}`}
                      {product.variants && product.variants.length > 0 && (
                        <>
                          {(product.ram || product.storage) && " | "}
                          {product.variants
                            .map((variant) => Object.values(variant).join(", "))
                            .join(", ")}
                        </>
                      )}
                      {product.suffix && (
                        <>
                          {(product.ram ||
                            product.storage ||
                            (product.variants &&
                              product.variants.length > 0)) &&
                            " | "}
                          {product.suffix}
                        </>
                      )}
                      {product.used_mobile !== undefined &&
                        product.used_mobile !== null && (
                          <>
                            {(product.ram ||
                              product.storage ||
                              (product.variants &&
                                product.variants.length > 0) ||
                              product.suffix) &&
                              " | "}
                            {product.used_mobile === false ? "New" : "Used"}
                          </>
                        )}
                    </div>
                  </div>
                </td>

                <td>{product.category_name || "N/A"}</td>
                <td>€{parseFloat(product.avg_buying_price || 0).toFixed(2)}</td>
                <td>
                  €{parseFloat(product.avg_selling_price || 0).toFixed(2)}
                </td>
                <td>{product.in_stock || 0}</td>
                <td className="status-cell">
                  <span
                    className="status-dot"
                    style={{
                      backgroundColor: getStatusColor(product.status),
                    }}
                  ></span>
                </td>
                <td>
                  <div className="action-buttons">
                    <button
                      className={`${isPartsURL ? "action-btn-parts view" : isAccessoriesURL ? "action-btn-acc view" : "action-btn view"}`}
                      onClick={() => onView(product)}
                      title="View"
                    >
                      <EyeIcon fill={isPartsURL ? "var(--primary-color-parts)" : isAccessoriesURL ? "var(--primary-color-acc)" : "var(--primary-color-mobile)"} />
                    </button>
                    <button
                      className={`${isPartsURL ? "action-btn-parts view" : isAccessoriesURL ? "action-btn-acc view" : "action-btn view"}`}
                      onClick={() => onEdit(product)}
                      title="Edit"
                    >
                      <EditIcon fill={isPartsURL ? "var(--primary-color-parts)" : isAccessoriesURL ? "var(--primary-color-acc)" : "var(--primary-color-mobile)"} />
                    </button>
                    <button
                      className="action-btn delete"
                      onClick={() => onDelete(product)}
                      title="Delete"
                    >
                      <RedDeleteIcon />
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ProductTable;
